import React from 'react';

import {
  STATE_TYPE,
  TOLL_FREE_NUMBER,
  SPECIAL_DISTRIBUTION_STATES,
} from '../../settings/settings';
import styles from '../../containers/TaxWithholding/TaxWithholding.module.scss';
import Phone from '../Phone/Phone';
import config from '../../config/config';

export const StateDisclosureContent = (props) => {
  const { stateType, percentage } = props;

  let { stateName } = props;
  stateName.sort((a, b) => {
    const temp1 = a.stateName.toLowerCase();
    const temp2 = b.stateName.toLowerCase();
    if (temp1 < temp2) {
      return -1;
    }
    if (temp1 > temp2) return 1;
    return 0;
  });

  function getPercentageText(stateObj) {
    if (stateObj.stateCode === 'DC') {
      return (
        <span>
          ({stateObj.percentage}% of the distribution when taking a total
          distribution from an account)
        </span>
      );
    } else if (
      stateObj.stateCode === 'AR' ||
      stateObj.stateCode === 'KS' ||
      stateObj.stateCode === 'NC'
    ) {
      return (
        <span>
          ({stateObj.percentage}% of distribution when distributions are greater
          than $200)
        </span>
      );
    } else if (stateObj.stateCode === 'CA' || stateObj.stateCode === 'VT') {
      return <span>({stateObj.percentage}% of federal withholding)</span>;
    } else {
      return <span>({stateObj.percentage}% of distribution)</span>;
    }
  }

  function getSingleStateText(stateCode) {
    if (stateCode === 'CA' || stateCode === 'VT') {
      return <span>of federal withholding</span>;
    } else if (
      SPECIAL_DISTRIBUTION_STATES.indexOf(stateCode) > -1 ||
      stateCode === 'MN' ||
      stateCode === 'CT' ||
      stateCode === 'MI' ||
      stateCode === 'OK' 
      ) {
      return <span>of your redemption amount</span>;
    } else {
      return <span>of the distribution</span>;
    }
  }
  const isFlagTrue =
    stateName[0].stateCode === 'CT' ||
    stateName[0].stateCode === 'MI' ||
    stateName[0].stateCode === 'MN' ||
    stateName[0].stateCode === 'DC' ||
    stateName[0].stateCode === 'OK';
  const showStateDisclosure = () => {
    const state = stateName[0].stateCode;
    const stateFullName = stateName[0].stateName;
    const withholdingPercent = percentage[0].percentage;
    return (
      <ul>
        <li>
          Your IRA is associated with an address{' '}
          {state === 'DC' ? 'in the ' : 'in '}
          <span className="emphasis">{stateFullName}</span>
          {state !== 'CT' ? ', where state income tax' : '.'}{' '}
          {state === 'DC'
            ? 'withholding will be withheld':state==='CT'?'We will withhold'
            : 'withholding is'}{' '}
          {state === 'DC' && 'at the rate of '}
          <span className="emphasis">
            {withholdingPercent}%{' '}
            {state === 'DC'
              ? 'from your distribution.'
                : state === 'CT'
                ? 'of your redemption amount unless you direct us otherwise.'
                : 'of your redemption amount.'}{' '}
          </span>
        </li>
        
        <li>
          You can elect out of {state === 'DC' ? 'this': state === 'CT'?'the state ' : 'the default state'}{' '}
          withholding by contacting us and{' '}
          {state === 'DC' ? 'requesting' : 'processing'} the transaction by
          phone
          {state === 'DC'
            ? ' or by paper distribution request.'
            : `. Withholding will not
              occur on direct rollovers.`}{' '}
          {state && state !== 'DC' && (
            <>
              You will be required to submit Form{' '}
                {state === 'OK'
                    ? state + "-W-4-R"
                    : state === 'MI'
                    ? state + " W-4P":
                    state === 'CT'
                    ? state + "-W4P"
                    : "W-4" + state + "P"}{' '}
                to elect out of withholding for{' '}
                {state === "OK"
                    ? "other distributions including": state === "CT"?"distributions other than"
                    : "distribution other than"}{' '}
                a conversion from a Traditional IRA to Roth IRA.
            </>
            )}
        </li>
        {state !== 'DC' && (
          <li>
            If you continue your transaction online{state === 'CT'?',':''} we will treat that as an
            election to withhold{' '}
            {stateFullName}
            {' '}income tax on any type of distribution except a rollover.
          </li>
        )}
      </ul>
    );
  };

  switch (stateType) {
    case STATE_TYPE.SPECIAL_STATE_TAX:
      return (
        <>
          <div className={styles['tax-modal-title']}>
            State Income Tax Withholding Disclosure
          </div>
          <div className={styles.list}>
            {isFlagTrue ? (
              showStateDisclosure()
            ) : (
              <ul>
                <li>
                  <span className="emphasis">
                    State income tax may be withheld
                  </span>{' '}
                  from your distribution under the applicable state law if the
                  address associated with your investments is in a default
                  withholding state.
                </li>
                <li>
                  Your investments are associated with an address in{' '}
                  <span className="emphasis">{stateName[0].stateName},</span>{' '}
                  where state income tax withholding will be applied. Mandatory{' '}
                  {stateName[0].stateName} state income tax withholding will
                  occur, using a status of “single, with zero exemptions” and
                  the {stateName[0].stateName} withholding tax tables unless you
                  provide {stateName[0].stateName} Form W-4MNP prior to
                  processing your distribution. The amount showing as “Estimated
                  total take-home” has not been reduced by the state tax that
                  will occur.
                </li>
              </ul>
            )}
          </div>
        </>
      );
    case STATE_TYPE.MULTI_STATE:
      return (
        <>
          <div className={styles['tax-modal-title']}>
            State Income Tax Withholding Disclosure
          </div>
          <div className={styles.list}>
            {isFlagTrue ? (
              showStateDisclosure()
            ) : (
              <ul>
                <li>
                  <span className="emphasis">
                    State income tax may be withheld
                  </span>{' '}
                  from your distribution under the applicable state law if the
                  address associated with your investments is in a default
                  withholding state. `
                </li>
                <li>
                  Your investments are associated with the following{' '}
                  <span className="emphasis">default withholding states</span>{' '}
                  and state taxes will be withheld accordingly:
                </li>
                <div className={styles['states-list']}>
                  {stateName.map((obj) => (
                    <li className={styles['states-li-list']}>
                      <span className={styles['states-li-list-content']}>
                        {obj.stateName} {getPercentageText(obj)}
                      </span>
                    </li>
                  ))}
                </div>
              </ul>
            )}
          </div>
        </>
      );

    case STATE_TYPE.MANDATORY:
      return (
        <>
          <div className={styles['tax-modal-title']}>
            State Income Tax Withholding Disclosure
          </div>
          <div className={styles.list}>
            {isFlagTrue ? (
              showStateDisclosure()
            ) : stateName[0].stateCode !== 'IA' ? (
              <ul>
                <li>
                  Your IRA is associated with an address in{' '}
                  <span className="emphasis">{stateName[0].stateName}</span>,
                  where state income tax withholding is{' '}
                  <span className="emphasis">
                    {percentage[0].percentage}%{' '}
                    {getSingleStateText(stateName[0].stateCode)}.
                  </span>
                </li>
                <li>
                    {[...SPECIAL_DISTRIBUTION_STATES].indexOf(
                      stateName[0].stateCode
                    ) > -1 && (
                      <span>
                       State withholding calculations are rounded to the nearest dollar based on entered redemption amount.  State withholding is declined automatically should you elect to decline the federal withholding. If you elected out of federal income tax withholding but would like state income tax withholding,
                      </span> 
                    )}{' '}
                    <a
                      className={'error-link'}
                      rel="noopener noreferrer"
                      href={`${config.url}/personal-investing/help/contact/index.html`}
                      target="_blank"
                    >
                      contact us
                    </a>{' '}
                  </li>
                </ul>
            ) : (
              <ul>
                <li>
                  Your IRA is associated with an address in{' '}
                  <span className="emphasis">{stateName[0].stateName}</span>. If
                  over the age of 55 or disabled, state withholding is not
                  required.  If you do not want to have IA income tax
                  withholding apply please{' '}
                  <a
                    className={'error-link'}
                    rel="noopener noreferrer"
                    href={`${config.url}/personal-investing/help/contact/index.html`}
                    target="_blank"
                  >
                    contact us
                  </a>{' '}
                  to process your trade.
                </li>
                <li>
                  If you continue processing your distribution online we will
                  treat that as an election to withhold{' '}
                  <span className="emphasis">{stateName[0].stateName}</span>{' '}
                  income tax at a rate of 5%. 
                </li>
              </ul>
            )}
          </div>
        </>
      );

    case STATE_TYPE.SPECIAL_STATES:
      return (
        <>
          <div className={styles['tax-modal-title']}>
            State Income Tax Withholding Disclosure
          </div>
          <div className={styles.list}>
            {isFlagTrue ? (
              showStateDisclosure()
            ) : (
              <ul>
                {stateName[0].stateCode !== 'AR' &&
                  <>
                    <li>
                      <span className="emphasis">
                        State income tax may be withheld
                      </span>{' '}
                      from your distribution under the applicable state law if the
                      address associated with your investments is in a default
                      withholding state.
                    </li>
                    <li>
                      Your investments are associated with an address in in{' '}
                      <span className="emphasis">{stateName[0].stateName}</span>,
                      where state income tax withholding is{' '}
                      {percentage[0].percentage}% of the distribution. No state tax
                      will be withheld if you have elected out of withholding with
                      form {stateName[0].stateCode === 'MI' ? 'MI-W4P' : 'CT-W4P'}.{' '}
                    </li>
                  </>
                }
                {stateName[0].stateCode === 'AR' &&
                  <>
                    <li>
                      Your IRA is associated with an address in{' '}
                      <span className="emphasis">{stateName[0].stateName}</span>,
                      where state income tax withholding is{' '}
                      <span className="emphasis">
                        {percentage[0].percentage}%{' '}
                        {getSingleStateText(stateName[0].stateCode)}.
                      </span>
                    </li>
                    <li>
                    State withholding calculations are rounded to the nearest dollar based on entered redemption amount.  State withholding is declined automatically should you elect to decline the federal withholding. If you elected out of federal income tax withholding but would like state income tax withholding, 
                    <a
                      className={'error-link'}
                      rel="noopener noreferrer"
                      href={`${config.url}/personal-investing/help/contact/index.html`}
                      target="_blank"
                    >
                      contact us
                    </a>{' '}
                    </li>
                    
                  </>
                }
              </ul>
            )}
          </div>
        </>
      );

    case STATE_TYPE.DC_SPECIAL_STATE:
      return (
        <>
          <div className={styles['tax-modal-title']}>
            State Income Tax Withholding Disclosure
          </div>
          <div className={styles.list}>
            {isFlagTrue ? (
              showStateDisclosure()
            ) : (
              <ul>
                <li>
                  <span className="emphasis">
                    State income tax may be withheld
                  </span>{' '}
                  from your distribution under the applicable state law if the
                  address associated with your investments is in a default
                  withholding state.
                </li>
                <li>
                  Your investments are associated with an address in{' '}
                  <span className="emphasis">{stateName[0].stateName}</span>,
                  where state income tax withholding is{' '}
                  {percentage[0].percentage}% of the distribution when taking a
                  total distribution from an account.
                </li>
                <li className="emphasis">
                  Withholding will be applied on all lump sum distributions.
                  Call <Phone phoneNumber={TOLL_FREE_NUMBER} /> to decline state
                  income tax withholding.
                </li>
              </ul>
            )}
          </div>
        </>
      );

    default:
      return '';
  }
};

export default StateDisclosureContent;
